module.exports = __webpack_public_path__ + "img/icon-mom.6e1a91b9.jpg";